{
  "version": 1,
  "asset_id": "bfec557d-9a2e-483c-b147-0a50e5529338",
  "project_id": "949ac23c-9e33-4376-b191-e19499cf4fa3",
  "url": "/__l5e/assets-v1/bfec557d-9a2e-483c-b147-0a50e5529338/beylikduzu-hizli-elektrikci-7-24-dukkan-4.jpg",
  "r2_key": "a/v1/949ac23c-9e33-4376-b191-e19499cf4fa3/bfec557d-9a2e-483c-b147-0a50e5529338/beylikduzu-hizli-elektrikci-7-24-dukkan-4.jpg",
  "original_filename": "beylikduzu-hizli-elektrikci-7-24-dukkan-4.jpg",
  "size": 475904,
  "content_type": "image/jpeg",
  "created_at": "2026-09-20T08:13:39Z"
}
